<template>
  <div class="calendar" ref='singleCalendar'>
    <div class="placeholder-container"
      :class="{ 'error': invalid }">
      <input type="text"
        placeholder=" "
        name="date"
        class="mainInp calendarInp"
        :class="{focus:show}"
        :value="value_"
        @change="onChange($event.target.value)"
        @focus="onInputFocus()"
        readonly />
      <label for="start">{{ placeholder }}</label>
    </div> <!-- placeholder-container -->
    <div class="calendar-container"
      v-show="show">
      <v-date-picker
        :value="value"
        @input="onInput"
        mode="date"
        is-required
        trim-weeks
        :step="1"
        :locale="locale"
        :min-date="minDate"
        :max-date="maxDate"
        :masks="masks"
        :columns="1"
        :rows="1"
        :is-expanded="false">
        <template v-slot:header="page">
          <div class="vc-title">{{ page.monthLabel }} {{ page.yearLabel }}</div>
        </template>
        <template v-slot:header-left-button>
          <div class="prevMonth"></div>
        </template>
        <template v-slot:header-right-button>
          <div class="nextMonth"></div>
        </template>
      </v-date-picker>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import { enGB as en, arSA as ar } from 'date-fns/locale'

export default {
  name: 'CalendarInput',
  props: {
    value: {},
    minDate: {},
    maxDate: {},
    invalid: {},
    placeholder: { type: String, default: '' }
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    formatLocale () {
      if (this.locale === 'ar') {
        return ar
      } else {
        return en
      }
    },
    show () {
      return this.inputFocused
    },
    invalid_ () {
      return !!this.invalid || false
    },
    value_ () {
      return this.formatDate(this.value)
    },
    formatString () {
      return this.locale === 'ar' ? 'd MMMM yyyy' : 'd MMM yyyy'
    }
  },
  data () {
    return {
      masks: {
        input: 'D MMM YYYY',
        weekdays: 'WWW'
      },
      inputFocused: false
    }
  },
  methods: {
    formatDate (value) {
      const marker = this.locale === 'ar' ? '\u200f' : ''
      return value ? format(value, `${marker}${this.formatString}`, { locale: this.formatLocale }) : ''
    },
    parseDate (value) {
      const now = new Date()
      const result = parse(value, this.formatString, new Date(now.getFullYear(), now.getMonth(), now.getDate()))
      return result instanceof Date && !isNaN(result) ? result : null
    },
    onChange (value) {
      this.$emit('input', this.parseDate(value))
    },
    onInputFocus () {
      this.inputFocused = true
    },
    onInput (value) {
      this.inputFocused = false
      this.$emit('input', value)
    },
    hideCalendar () {
      this.inputFocused = false
    },
    closeCalendar ($event) {
      const el = $event.composedPath()
      const calendareBody = this.$refs.singleCalendar
      if (!el.includes(calendareBody)) {
        this.hideCalendar()
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.closeCalendar)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeCalendar)
  }
}
</script>
